import alpha from "color-alpha";
const MuiRadio = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      padding: "8px",
      margin: "-8px",
      color: theme.palette.grey[800],
      "&:hover": {
        backgroundColor: alpha(theme.palette.grey[800], 0.08)
      },
      "&.Mui-checked": {
        color: theme.palette.primary[800],
        // aqua → primary
        "&:hover": {
          backgroundColor: alpha(theme.palette.primary[800], 0.08)
        }
      },
      "&.Mui-disabled": {
        color: alpha(theme.palette.grey[800], 0.38)
      }
    })
  }
};
export {
  MuiRadio
};
